export const ENTERVALUE = 'You must enter a value';

export const PASSWORDREQUIREMENTS =
    'Password must be eight characters, contain one capital, one lowercase, one number, and one symbol (!@#$%^&*-?)';

export const ENTEREMAIL = 'You must enter a valid email';
